// src/store/index.js
import { createStore } from 'vuex'
import { persistState } from '@/plugins/persistState';


export const initialState = () => {
  return {
    isLoading: false,
  }
};

export const store = createStore({
  state: initialState(),
  mutations: {
  
    setLoading(state, loadingState) {
      state.isLoading = loadingState;
    },
   
    reset(state) {
      Object.assign(state, initialState());
    }
  },
  actions: {
   
    setLoading({ commit }, loadingState) {
      commit('setLoading', loadingState);
    },
    reset({ commit }) {
      commit('reset');
    }


  },
  getters: {
    
  },
  plugins: [persistState],
})
